module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cfldS"))).then(() => parcelRequire('1iHdE'));